var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.headerVisible)?_c('BasicToolbar',{attrs:{"name":_vm.name}}):_vm._e(),_c('v-data-table',{staticClass:"elevation-1",class:_vm.type,attrs:{"headers":_vm.tableConfig.headers,"items":_vm.items,"hide-default-footer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }